import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import ABS from "../../assets/ABS.png";

const ABSSystem = () => {
  return (
    <>
      <SeoHead
        title="ABS Brake System Repair in Temecula | Advanced Automotive Smog"
        description="ABS diagnostics and repair in Temecula to keep your anti-lock braking system responsive, supporting shorter stopping distances and steering control."
        path="/services/abs-system"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="ABS System Service"
          path="/services/abs-system"
          description="ABS diagnostics and repair in Temecula to keep your anti-lock braking system responsive."
          serviceType="ABS system repair"
        />
        
        {/* Layout container */}
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={ABS}
                alt="ABS System Illustration"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Brake Safety Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-navy-900 mb-3">
              ABS System Service
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Keep your stopping power sharp and your family safe. We diagnose,
              repair, and test your Anti-lock Braking System so your vehicle
              can react when the road doesn&apos;t.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What is the ABS System?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              The Anti-lock Braking System (ABS) helps prevent your wheels from
              locking up during hard braking, especially on wet or slippery
              roads. That means better steering control, shorter stopping
              distances, and more confidence behind the wheel.
              <br /><br />
              Our technicians inspect, diagnose, and repair your ABS components
              using modern diagnostic tools to make sure everything is working
              exactly as it should.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Complete ABS diagnostics and sensor checks</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Professional ABS control module and wiring repairs</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>High-quality parts and up-to-date equipment</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Improved braking stability and safety on the road</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Full road-ready testing after every repair</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>
        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default ABSSystem;
